// Resolver for multilingual blog articles.
// English holds the canonical structure + non-translatable fields (date, author, image);
// FR/TR override only translatable text and inherit the rest from EN.
import { BLOG_POSTS_EN } from "./blog.en";
import { BLOG_POSTS_FR } from "./blog.fr";
import { BLOG_POSTS_TR } from "./blog.tr";

const BY_LANG = { en: BLOG_POSTS_EN, fr: BLOG_POSTS_FR, tr: BLOG_POSTS_TR };

export const BLOG_SLUGS = Object.keys(BLOG_POSTS_EN);

// Returns a single post merged with its EN base, or undefined if the slug is unknown.
export const getBlogPost = (slug, lang = "en") => {
  const base = BLOG_POSTS_EN[slug];
  if (!base) return undefined;
  const override = (BY_LANG[lang] || {})[slug];
  return override ? { ...base, ...override } : base;
};

// Returns all posts (merged) as an ordered array of { slug, ...post }.
export const getBlogPosts = (lang = "en") =>
  BLOG_SLUGS.map((slug) => ({ slug, ...getBlogPost(slug, lang) }));
